import {
  SET_MAP_BASE_LAYER,
  SET_MAP_OVERLAYER,
  SET_ZOOM,
  SET_CENTER_MAP,
  SET_MAP_BOUNDS,
  VIEW_CUSTOM_MAP,
  SET_SEARCH_LOCATION,
} from "../actions/mapBaseLayerControlAction";

import { states } from "./queriesStates";
import { CRS } from "leaflet";
import configuration from "./../config.json";

const initialState = {
  dataState: states.READY,
  baseLayer: {
    name: "Osm",
    crs: CRS.EPSG900913,
    url: [
      configuration.isLocalApp && configuration.localAppConfig.localMapTilesUrl !== null
        ? configuration.localAppConfig.localMapTilesUrl
        : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    ],
    maxZoom: 19,
  },
  overlayers: {
    viewRoute: true,
    viewOrigenalPositions: false,
    viewStopMarker: true,
    viewFuelingMarker: true,
    viewDrainMarker: true,
    viewGpsJammingMarker: true,
    viewSpeedingPointsMarker: true,
    viewPosition: true,
    viewStartFinishMarker: true,
    viewGeozones: true,
  },
  zoom: 8,
  mapCenter: { lat: 54, lng: 28 },
  mapBounds: null,
  searchMapMarkerLocation: null,
  isViewCustomMap: false,
};

const mapMapBaseLayerControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAP_BASE_LAYER:
      return Object.assign({}, state, {
        dataState: states.READY,
        baseLayer: action.baseLayer,
      });
    case SET_MAP_OVERLAYER:
      return Object.assign({}, state, {
        dataState: states.READY,
        overlayers: action.overlayers,
      });

    case SET_ZOOM:
      return Object.assign({}, state, {
        dataState: states.READY,
        zoom: action.zoom,
      });
    case SET_CENTER_MAP:
      return Object.assign({}, state, {
        dataState: states.READY,
        mapCenter: action.mapCenter,
        mapBounds: null,
      });
    case SET_MAP_BOUNDS:
      return Object.assign({}, state, {
        dataState: states.READY,
        mapBounds: action.mapBounds,
      });

    case VIEW_CUSTOM_MAP:
      return Object.assign({}, state, {
        isViewCustomMap: action.isViewCustomMap,
      });

    case SET_SEARCH_LOCATION:
      return Object.assign({}, state, {
        searchMapMarkerLocation: action.location,
      });
    default:
      return state;
  }
};

export default mapMapBaseLayerControlReducer;
